import React, { useState } from "react";

// Helper Imports
import {
  formatCurrency,
  formatLabels,
  formatDate,
  formatAdjectives,
} from "../../../../Helpers/formatters";

import { PROCESS_ORDER } from "../../../../Helpers/trigger_constants";

// MUI Imports
import { IconButton } from "@mui/material";
import Collapse from "@mui/material/Collapse";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import CloseIcon from "@mui/icons-material/Close";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";

// Component Imports
import EditModal from "../../../../Components/EditModal";
import ToolTip from "../../../../Components/Interactive/ToolTip";

// More JSX Imports
import MoreOrderDetailsTable from "./MoreOrderInformation/MoreOrderDetailsTable";

const CustomerOrderRow = ({
  row,
  customerId,
  orderPaymentData,
  auth,
  setUpdatedData,
  setTrigger,
}) => {
  const [open, setOpen] = useState(false);
  const [modalIsOpen, setModalOpen] = useState(false);
  const [creditAmount, setCreditAmount] = useState(row.orderTotal);
  const [creditType, setCreditType] = useState("Refund Credit Card");
  const [refundTypes, setRefundTypes] = useState([]);

  const handleOpen = async (e, orderId) => {
    const res = await fetch(`/api/customer/${orderId}/refund-types`);
    const { result } = await res.json();
    setRefundTypes(result);
    setModalOpen(true);
  };
  const handleClose = (e) => setModalOpen(false);

  const submitRefund = async (e) => {
    if (
      creditType === "Log Credit Only (do not process)" ||
      creditType === "Refund Credit Card"
    ) {
      const options = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          OrderId: row.orderNumber,
          UserID: auth.userInfo.userData.userId,
          Amount: creditAmount,
          LogOnly: creditType === "Log Credit Only (do not process)",
        }),
      };
      const res = await fetch(
        `/api/customer/${customerId}/refund-order`,
        options
      );
      const { success } = await res.json();

      setUpdatedData({
        updateData: {
          state: success ? true : false,
          message: success
            ? "Order refunded / updated successfully"
            : "There was an error refunding / updating this order",
        },
      });
      if (!success) {
        setModalOpen(false);
        return;
      }
    } else if (creditType === "Void / Cancel") {
      const options = {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          OrderId: row.orderNumber,
          UserID: auth.userInfo.userData.userId,
        }),
      };
      const res = await fetch(
        `/api/customer/${customerId}/cancel-order`,
        options
      );
      const { success } = await res.json();
      setUpdatedData({
        updateData: {
          state: success ? true : false,
          message: success
            ? "Order cancelled successfully"
            : "There was an error canceling this order",
        },
      });
      if (!success) {
        setModalOpen(false);
        return;
      }
    }
    setTrigger(PROCESS_ORDER);
    setModalOpen(false);
    setCreditAmount(row.orderTotal);
  };
  return (
    <>
      <EditModal open={modalIsOpen} handleClose={handleClose}>
        <div className="modal-header">
          <h2 style={{ padding: ".5rem", color: "#6acde6" }}>Issue Refund</h2>
          <CloseIcon className="close-icons" onClick={() => handleClose()} />
        </div>
        <h4 style={{ padding: ".5rem", color: "#d8e4e9" }}>
          Order Number - {row?.orderNumber}
        </h4>
        <h4 style={{ padding: ".5rem", color: "#d8e4e9" }}>
          Processor - {row?.transactionDetails[0]?.mid}
        </h4>
        <h4 style={{ padding: ".5rem", color: "#d8e4e9" }}>
          Order Amount - {formatCurrency(row?.orderTotal)}
        </h4>
        <h4
          style={{ padding: ".5rem", color: "#d8e4e9", marginBottom: "1rem" }}
        >
          Status - {row?.transactionDetails[0]?.message}
        </h4>
        <FormControl
          variant="outlined"
          style={{ margin: 8, width: "18rem" }}
          onChange={(e) => setCreditAmount(e.target.value)}
        >
          <InputLabel htmlFor="outlined-age-native-simple">
            {"Credit Amount"}
          </InputLabel>
          <Select defaultValue={creditAmount} native={true} label={"Cancel"} onChange={e => setCreditAmount(e.target.value)}>
            {refundTypes?.map(({ amount, description }, idx) => {
              if(amount <= row.orderTotal) {
                return (
                  <option key={idx} value={amount}>
                    {description}
                  </option>
                );
              } else {
                return null;
              }
            })}
          </Select>
        </FormControl>
        <FormControl
          variant="outlined"
          style={{ margin: 8, width: "18rem" }}
          onChange={(e) => setCreditType(e.target.value)}
        >
          <InputLabel htmlFor="outlined-age-native-simple">{"Type"}</InputLabel>
          <Select native={true} label={"Cancel"}>
            {[
              "Refund Credit Card",
              "Void / Cancel",
              "Log Credit Only (do not process)",
            ].map((action, idx) => {
              return (
                <option key={idx} value={action}>
                  {action}
                </option>
              );
            })}
          </Select>
        </FormControl>
        <div className="modal-btn-box">
          <button className="submit-btn-payment" onClick={submitRefund}>
            <span>Issue Refund</span>
          </button>
        </div>
      </EditModal>
      <TableRow className="order-row table-row">
        <TableCell className="tableCell">
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? (
              <KeyboardArrowUpIcon className="tableCell" />
            ) : (
              <KeyboardArrowDownIcon className="tableCell" />
            )}
          </IconButton>
        </TableCell>
        <TableCell align="center" className="tableCell">
          {row.orderNumber}
        </TableCell>
        <TableCell
          scope="row"
          className="tableCell"
          style={{ textAlign: "center !important" }}
        >
          {row.campaign}
        </TableCell>
        <TableCell align="center" className="tableCell">
          {formatCurrency(row.orderTotal)}
        </TableCell>
        <ToolTip
        placement="top"
        titleHeading="Order Message"
        titleData={row.orderMessage}
        >
          <TableCell align="center" className="tableCell">
            <span className={formatLabels(row.status)} title={row.status === "Refund" ? row?.parentOrderId : null}>
              {formatAdjectives(row.status)}
            </span> 
          </TableCell>
        </ToolTip>
        <TableCell
          align="center"
          className="tableCell"
          style={{ borderBottom: "none !important" }}
        >
          {formatDate(row.date)}
        </TableCell>
        <TableCell align="center" className="tableCell">
          <span>
            {row?.products[0]?.productId ? row?.products[0]?.productId : "n/a"}
          </span>
        </TableCell>
        <TableCell align="center" className="tableCell">
          <span>
          {row?.products[0]?.productTypeName ? row?.products[0]?.productTypeName : "n/a"}
          </span>
        </TableCell>
        <TableCell align="center" className="tableCell">
          <span>
          {row?.products[0]?.productName ? row?.products[0]?.productName : "n/a"}
          </span>
        </TableCell>
        <TableCell align="center" className="tableCell">
          <span>
          {row?.products[0]?.quantity ? row?.products[0]?.quantity : "n/a"}
          </span>
        </TableCell>
        <TableCell align="center" className="tableCell">
          <span>
          {row?.products[0]?.sku ? row?.products[0]?.sku : "n/a"}
          </span>
        </TableCell>
        <TableCell align="center" className="tableCell">
          <span>
          {row?.products[0]?.price ? formatCurrency(row?.products[0]?.price ) : "n/a"}
          </span>
        </TableCell>
        <TableCell align="center" className="tableCell">
          {formatAdjectives(row.status) === "Success" ? (
            <button
              className="add-note-btn-open"
              onClick={(e) => handleOpen(e, row.orderNumber)}
            >
              <span style={{color: "#fff"}}>Issue Refund</span>
            </button>
          ) : null}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={13}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <MoreOrderDetailsTable row={row} orderPaymentData={orderPaymentData}/>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default CustomerOrderRow;
